export default function Worker_fn() {
  return new Worker(__webpack_public_path__ + "search.worker-9d7107a25237f5491157.worker.js");
}
